import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'workbooks',
	landing: {
		route: null,
	},
	funnel: {
		id: 'crm_workbooks',
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'crm_workbooks',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-email',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
